export const DOWN_ARROW_STYLE = {
  size: 16,
  color: '#080928',
} as const;

export const PRICE_FILTER_PILL_TEXT = 'Price';
